import { NgxsReduxDevtoolsPluginModule } from '@ngxs/devtools-plugin';

export const environment = {
  production: false,
  hideElttoUi: false,
  apiUrl: 'https://auth.dev2.mountainseedapp.com/api',
  elttoUrl: 'https://eltto.dev2.mountainseedapp.com/',
  miUrl: 'https://mi.dev2.mountainseedapp.com/',
  ngxs: {
    plugins: [NgxsReduxDevtoolsPluginModule.forRoot({ name: 'Auth' })],
  },
  gaId: 'G-N8S2M90J40',
};
